
import Figma from "../../../assets/duotone/Figma.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FigmaIcon({ className, dataTestid = "FigmaIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Figma data-testid={dataTestid} className={classes} {...rest} />
  );
}
